class fixTemplate {
    constructor($injector) {
        this.state = $injector.get('$state');
        this.sweetAlert = $injector.get('SweetAlert');
        this.api = $injector.get('$http');
        this.locale = $injector.get('locale');
        this.translate = $injector.get('$translate');

        this.key = 'fix-template';
        this.title = this.translate.instant('templates.workflows.details.fix-template.title');
        this.level = 'highlight';
        this.icon = 'fal fa-wrench';
        this.order = 40;
    }

    action(template, vm) {
        this.api.post('templates/' + template.id + '/fix-beefree').then(() => {
            this.sweetAlert.swal(this.locale.getString('templates.template_fixed'), this.locale.getString('templates.template_fixed_json'), 'success');
            vm.reloadTemplate();
        });
    }

}

angular
    .module('festzelt-os.modules.templates')
    .factory('fixTemplate', [
        '$injector',
        ($injector) => new fixTemplate($injector)
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/templates/workflows/details/fix-template.js